module.exports = __webpack_public_path__ + "static/media/WB_Yoga.b1849c40.png";